@if (isSupportOfficerAssociated) {
  <div class="grid">
    @for (officer of supportOfficer; track officer; let ri = $index) {
      <div class="col-12 md:col-6 lg:col-4">
        <div class="purple-brand-bar"></div>
        <p-card
          header="{{ officer.title }} {{ officer.name }}"
          subheader="{{ officer.role ? officer.role : officer.remarks }}"
        >
        </p-card>
      </div>
    }
  </div>
}
@if (!isSupportOfficerAssociated) {
  <div class="col-12">
    {{ noSupportOfficerAssociatedText }}
  </div>
}
